'use strict';

// dom
const {
	div
} = require('iblokz-snabbdom-helpers');

// list: shared grid; edit: custom (users have no rest schema / password must stay out of form binding)
const list = require('../resources/list');
const edit = require('./edit');

module.exports = ({state, actions, i18n}) => div('.admin-resources', [].concat(
	!state.router.pageId
		? list({state, actions, i18n})
		: edit({state, actions, i18n})
));
